import React from 'react'
import { Link } from 'react-router-dom'

function Minimal() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">MINIMAL</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newminimal1.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">MINIMAL</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Less is more, a multitude of options for endless configurations.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">MINIMAL display case range was design to meet the requirements of the new food exposition concepts for Pastry and Bakery products. Its unique design, also available in slimline models, is combined with advanced solutions which facilitate the service and confer extraordinary visibility that enhances the qualities of your products.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <div className="flex flex-col gap-3 md:flex-row justify-center items-center">
         <p className="text-xl lg:text-2xl opacity-90">Pastry</p>
         <p className="text-xl font-thin opacity-70"><span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       </div>
       <p className="text-xl lg:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
       <p className="text-xl lg:text-2xl opacity-90">Pastry / Chocolates<span  className='text-gray-400'> (dual temperature)</span><span className='text-blue-400'>-1… +7 °C</span> <span  className='text-gray-400'>(3M2)</span>  <span className='text-blue-400'>+13… +15 °C</span> <span  className='text-gray-400'>(3S)</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(hot plate)</span><span className='text-red-500'>+65 °C</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-32">
  {[
    {
      img: "images/minicard.jpg",
      text: "Available in two widths, 73 cm and 90 cm, to suit your space and business needs.",
    },
    {
      img: "images/minicard1.jpg",
      text: "The raised and height-adjustable display deck allows products of different heights to be accommodated.",
    },
    {
      img: "images/minicard2.jpg",
      text: "Passive and low energy consumption front glass anti-condensation system.",
    },
    {
      img: "images/minicard3.gif",
      text: "Wide range of front glass options like low straight glass (VDB-UV) high straight glass (VDA-UV), high straight glass with one shelf for non refrigerated products (VDA) and high straight glass with one shelf and sneeze guard (VDAP).",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 md:mt-10 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Snacks and desserts by morning, Chocolates in the afternoon</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Versatile product conservation and presentation with just a single press of a button. Dual temperature model (-1... +7 °C / +13... +15 °C) that allows switching between the pastry and chocolate products, and thus increase sales opportunities with just a single display unit.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/minicase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 md:mt-10 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/minicase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Your creations take the centre stage</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Plug-in chilled display case island format for Chocolates and Fine Pastry, 360° visibility without obstacles for your products. With caster wheels for easy relocation inside the store, sliding glass canopy and drawer for packages utensils that facilitates the service.</div>
</div>
             </div>
    
     {/* card & description */}
     <div className="flex flex-wrap gap-6 justify-center ">
  {[
    {
      img: "images/minimalcard.jpg",
      text: "360° visibility for Fine Pastry always with the best look and presentation",
    },
    {
      img: "images/minimalcard1.jpg",
      text: "Caster wheels for easy movement and repositioning within the store.",
    },
    {
      img: "images/minimalcard2.jpg",
      text: "Service drawer and sliding glass dome with key lock (optional extra) for greater service experience.",
    },
    
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
    
          
         </div>
     </div>
    
  
        </div>
      )
    }
export default Minimal